import React, { useEffect, useState } from 'react';
import { Button, Table, Card, Typography, Space, Alert, Divider } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import httpInjectorService from 'services/http-injector.service';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const { Title, Text } = Typography;

const columns = (restoreVersionHistory, deleteVersionHistory) => [
  {
    title: 'Version',
    render: (data) => (
      <Text strong={data.is_current === 1}>
        {data.is_current === 1
          ? `Current (V${data.version_number})`
          : `V${data.version_number}`}
      </Text>
    ),
  },
  {
    title: 'Date',
    dataIndex: 'created_at',
    render: (text) => (
      <Text type="secondary">{new Date(text).toLocaleDateString()}</Text>
    ),
  },
  {
    title: 'Time',
    dataIndex: 'created_at',
    render: (text) => (
      <Text type="secondary">
        {new Date(text).toLocaleTimeString('en', { hour12: true })}
      </Text>
    ),
  },
  {
    title: 'Changed by',
    dataIndex: 'author',
    render: (text) => <Text>{text}</Text>,
  },
  {
    title: 'Action',
    dataIndex: '',
    render: (_, record) => (
      <Space>
        <Button
          type="link"
          onClick={() => restoreVersionHistory(record)}
          disabled={record.is_current === 1}
        >
          Restore
        </Button>
        <Button
          type="link"
          danger
          onClick={() => deleteVersionHistory(record)}
          disabled={record.is_current === 1}
        >
          Delete
        </Button>
      </Space>
    ),
  },
];

export default function VersionHistory() {
  const [versionHistory, setVersionHistory] = useState([]);
  const [selectedVersionHistory, setSelectedVersionHistory] = useState([]);

  const { spaceid, pageid } = useParams();
  const navigate = useNavigate();

  const location = useLocation();
  const item_type = location.state?.item_type || 'page'; 

  const rowSelection = {
    onChange: (_, selectedRows) => {
      setSelectedVersionHistory(selectedRows);
    },
  };

  const getVersionHistory = async () => {
    try {
      const response = await httpInjectorService.getVersionHistory(
        spaceid,
        pageid,
        item_type,
      );

      if (response.status === 'success') {
        setVersionHistory(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const restoreVersionHistory = async (record) => {
    try {
      const payload = {
        space_id: Number(spaceid),
        item_id: Number(pageid),
        version_number: record.version_number,
        version_id: record.version_id,
      };
      const response = await httpInjectorService.restorePageVersion(payload);
      if (response.status === 'success') {
        getVersionHistory();
        toast.success(response.message || 'Version restored succesfully', {
          autoClose: 1000,
          position: 'top-right',
        });
      }
    } catch (error) {
      toast.error(error.message || 'Something went wrong', {
        autoClose: 1000,
        position: 'top-right',
      });
    }
  };

  const deleteVersionHistory = async (record) => {
    try {
      const response = await httpInjectorService.deleteVersion(
        Number(spaceid),
        Number(pageid),
        record.version_id,
      );
      if (response.status === 'success') {
        getVersionHistory();
        toast.success(response.message || 'Version deleted succesfully', {
          autoClose: 1000,
          position: 'top-right',
        });
      }
     
    } catch (error) {
      toast.error(error.message || 'Something went wrong', {
        autoClose: 1000,
        position: 'top-right',
      });
    }
  };

  useEffect(() => {
    getVersionHistory();
  }, []);

  return (
    <Card style={{ borderRadius: 12 }}>
      <div style={{ marginBottom: 12 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          style={{ paddingLeft: 0 }}
        >
          Back
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Title level={4} style={{ marginBottom: 0 }}>
            Version History
          </Title>
          <Text type="secondary">Select exactly 2 versions to compare</Text>
        </div>

        <Button
          type="primary"
          size="middle"
          disabled={selectedVersionHistory.length !== 2}
          style={{ backgroundColor: '#722ed1', color: 'white', minWidth: 180 }}
          onClick={() => {
            const [v1, v2] = selectedVersionHistory;

            const oldVersion = v1.version_number < v2.version_number ? v1 : v2;

            const currentVersion =
              v1.version_number > v2.version_number ? v1 : v2;

            navigate('compare', {
              state: {
                oldVers: oldVersion.version_id,
                currentVers: currentVersion.version_id,
                oldData: oldVersion,
                currentData: currentVersion,
              },
            });
          }}
        >
          Compare Versions
        </Button>
      </div>

      <Divider />

      <Table
        rowKey="version_id"
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        columns={columns(restoreVersionHistory, deleteVersionHistory)}
        dataSource={versionHistory}
        pagination={{ pageSize: 8 }}
      />

      <div style={{ marginTop: 16 }}>
        <Alert
          message="Only 2 versions can be compared"
          type="info"
          showIcon
          style={{ width: 'fit-content' }}
        />
      </div>
    </Card>
  );
}
